import {
  CATALOG_SOURCE_LABELS,
  formatRelatedProductLabel,
  formatRelatedProductMeta,
} from './searchRelatedProducts'

export const enrichRelatedProductFromCatalog = (product, searchIndex = []) => {
  if (!product?.id || product.brandId) {
    return product
  }

  const catalogProduct = searchIndex.find(
    (item) => item.id === product.id && (!product.source || item.source === product.source)
  )

  if (!catalogProduct) {
    return product
  }

  return {
    ...catalogProduct,
    label: formatRelatedProductLabel(catalogProduct),
    metaLabel: formatRelatedProductMeta(catalogProduct),
    sourceLabel: CATALOG_SOURCE_LABELS[catalogProduct.source],
  }
}

export default enrichRelatedProductFromCatalog
